var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.834 5H10.834M21.834 19H10.834M21.834 12H10.834M6.83398 5C6.83398 5.82843 6.16241 6.5 5.33398 6.5C4.50555 6.5 3.83398 5.82843 3.83398 5C3.83398 4.17157 4.50555 3.5 5.33398 3.5C6.16241 3.5 6.83398 4.17157 6.83398 5ZM6.83398 19C6.83398 19.8284 6.16241 20.5 5.33398 20.5C4.50555 20.5 3.83398 19.8284 3.83398 19C3.83398 18.1716 4.50555 17.5 5.33398 17.5C6.16241 17.5 6.83398 18.1716 6.83398 19ZM6.83398 12C6.83398 12.8284 6.16241 13.5 5.33398 13.5C4.50555 13.5 3.83398 12.8284 3.83398 12C3.83398 11.1716 4.50555 10.5 5.33398 10.5C6.16241 10.5 6.83398 11.1716 6.83398 12Z",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcList);
export default __webpack_public_path__ + "static/media/ic-list.19e8a782301f772adb534ff12d4fdd4a.svg";
export { ForwardRef as ReactComponent };